import type React from 'react';
import type { ReactElement } from 'react';

import classNames from 'classnames';

import {
  type AriaProps,
  ariaToReactProps,
} from '@iconik-io/shared-lib/src/react/a11y/aria';
import { Icon, type IconName, type IconSize } from '@iconik-io/uad';

import type { TooltipWrappedProps } from '../../components/tooltip_trigger/tooltip_trigger';
import type { IconType } from '../../icons/constants';
import LegacyIcon from '../../icons/icon';
import { ui } from '../../utils/helpers';
import type { ButtonVariant } from '../button/types';

import mixins from '../../styles/core/mixins.module.css';
import styles from './icon_button.module.css';

type Props = {
  className?: string;
  iconClassName?: string;
  // TODO: UAD Icons, delete icon prop after UAD icon migration
  icon?: IconType;
  // TODO: UAD Icons, make iconName prop required after UAD icon migration
  iconName?: IconName;
  // TODO: UAD Icons, delete iconSizeUAD prop after UAD icon migration
  iconSizeUAD?: IconSize;
  uiKey?: string;
  // TODO: UAD Icons, size prop should have the IconSize type after UAD icon migration
  size?: number;
  variant?: ButtonVariant;
  aria?: AriaProps;
} & TooltipWrappedProps &
  React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  >;

const IconButton = ({
  className,
  icon,
  iconName,
  iconSizeUAD,
  iconClassName,
  size,
  variant,
  uiKey,
  aria,
  type = 'button',
  ...buttonNativeProps
}: Props): ReactElement => (
  <button
    className={classNames(
      className,
      mixins.reset_button,
      mixins.hitbox_expand,
      styles.button,
      variant
        ? {
            [styles[variant]]: true,
          }
        : undefined,
    )}
    {...ariaToReactProps(aria)}
    {...ui(uiKey)}
    {...buttonNativeProps}
    type={type}
  >
    {iconName && (
      <Icon name={iconName} className={iconClassName} size={iconSizeUAD} />
    )}
    {!iconName && icon && (
      <LegacyIcon className={iconClassName} icon={icon} size={size ?? 18} />
    )}
  </button>
);

export default IconButton;
